<template>
  <div class="text-xs-center" v-if="loading">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
  <GChart
    v-else
    type="ColumnChart"
    :settings="chartSettings"
    :data="data"
    :options="chartOptions"
    :resizeDebounce="1000"
    :events="chartEvents"
    ref="gChart"
  />
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: "StackedBar",
  data() {
    return {
      data: [],
      chartOptions: {
        isStacked: this.stackedType ? this.stackedType : true,
        tooltip: { isHtml: true },
        width: '100%', height: 500,
        bar: {
          groupWidth: 20
        },
        explorer: {
          actions: ['dragToPan', 'rightClickToReset'],
          axis: 'horizontal'
        },
        legend: { textStyle: { fontSize: 12, fontName: 'Arial' } },
        hAxis: {
          format: ''
        },
        vAxis: {
          format: this.chartVAxFormat ? this.chartVAxFormat : ''
        },
        // Colours are ordered from the bottom up as they are rendered on the chart
        colors: [
          "#3366cc", // Converted
          "#dc3912", // Quote Accepted
          "#ff9900", // Quote Rejected
          "#109618", // Awaiting Acceptance
          "#990099", // Requote Requested
          "#0099c6", // Quote Sent - Not Followed Up
          "#dd4477", // Gathering Customer Requirements
          "#66aa00", // Lead Cancelled
          "#b82e2e" // New Lead
        ]
      },
      chartSettings: {
        packages: ['corechart']
      },
      chartEvents: {
        'select': () => {
          const table = this.$refs.gChart.chartObject;
          const selection = table.getSelection()[0];

          if (selection !== undefined) {
            const row = selection.row + 1;

            const element = {};
            element.viewType = this.$store.state.Dashboard.widgetConfig.viewType;
            element.name = this.chartData[row][0];

            this.$emit('bar-selected', element);
          }
        }
      }
    }
  },
  props: ['chartData', 'loading', 'stackedType', 'chartVAxFormat', 'bus', 'dimensions'],
  components: {GChart},
  created() {
    this.data = this.chartData;

    this.bus.$on('tab-changed', () => {
      console.log(this.$refs.gChart);

      const refChart = this.$refs.gChart;
      const chartObject = refChart.chartObject;

      setTimeout(function() {
        chartObject.clearChart();
        refChart.drawChart();
      }, 1);
    });
  },
  watch: {
    chartData: function(data) {
      this.data = data;
    }
  }
}
</script>

<style scoped>

</style>
